import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';

function NavbarComponent() {
  return (
    <Navbar expand="lg" fixed="top" className="navbar-custom">
      <Container>
        <Navbar.Brand href="/#home">JW</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" style={{ borderColor: 'rgba(255,255,255,0.3)' }}>
          <span style={{ display: 'block', width: '22px', height: '2px', background: '#fff', margin: '5px 0' }}></span>
          <span style={{ display: 'block', width: '22px', height: '2px', background: '#fff', margin: '5px 0' }}></span>
          <span style={{ display: 'block', width: '22px', height: '2px', background: '#fff', margin: '5px 0' }}></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/#home">Home</Nav.Link>
            <Nav.Link href="/#about">About</Nav.Link>
            <Nav.Link href="/#experience">Experience</Nav.Link>
            <Nav.Link href="/#skills">Skills</Nav.Link>
            <Nav.Link href="/#publications">Publications</Nav.Link>
            <Nav.Link href="/#contact">Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarComponent;
